import axios from 'axios';

export default {
  FETCH_FAQSECTIONS ({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      // axios.post('login/authenticate', payload)
      axios.get('common/getAllFaqSectionHeaders')
        .then((response) => {
          const { data: { data : { payload } } } = response;
          localStorage.setItem('faqsections', JSON.stringify(payload));
          commit('SET_FAQSECTIONS', payload);
          commit('TOGGLE_LOADING', false);
          resolve(payload);

        })
        .catch((error) => {
          console.log('action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  GETSELECTEDFAQSECTION ({ commit }, faqHeaderId) {
    commit('TOGGLE_LOADING', true);
    return axios.get(`common/getAllFaqSectionHeaders`).then((response) => {
      commit('TOGGLE_LOADING', false);
      const { data: { data : { payload }} } = response;

      console.log('payload', payload)
      let selectedFAQsection = payload.filter(x => {
        return x.faqHeaderId.toString() === faqHeaderId.toString()
      });

      console.log('found faq section', selectedFAQsection)
      commit('SET_SELECTED_FAQSECTION', selectedFAQsection[0])
    }, (err) => {
      commit('TOGGLE_LOADING', false);
      console.log('err ', err)
    })
  },
  ADD_FAQSECTION({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      console.log("add FAQ Section payload : ", payload);
      axios.post('common/insertFaqSectionHeader', payload)
        .then((response) => {
          console.log('ADD_FAQSECTION action fetch response : ', response);
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('ADD_TESTIMONIAL action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
  UPDATE_FAQSECTION({commit, dispatch}, payload){
    return new Promise((resolve, reject) => {
      commit('TOGGLE_LOADING', true);
      axios.post('/common/updateFaqSectionHeader', payload)
        .then((response) => {
          const { data: { data } } = response;
          commit('TOGGLE_LOADING', false);
          resolve(data);
        })
        .catch((error) => {
          console.log('UPDATE_FAQSECTION action fetch error : ', error);
          reject(error);
          commit('TOGGLE_LOADING', false);
        });
    })
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/faqsections/actions.js